<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Title" required="true" placeholder="i.e What's new?" />

                    <select-input v-model="form.category_id" :error="form.errors.category_id"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Category" required="true">
                        <option :value="null">Select Category</option>
                        <option v-for="category in categories" :key="category.id" :value="category.id">
                            {{ category.title }}
                        </option>
                    </select-input>

                    <text-input v-model="form.version_name" :error="form.errors.version_name"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Version" required="true" placeholder="i.e v1.0.0" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Slug" required="true" placeholder="i.e whats-new" />

                    <div class="pb-8 pr-6 w-full lg:w-1/1">
                        <label class="form-label" for="details">Details<span class="custom-error">*</span></label>
                        <vue-editor v-model="form.details" />
                    </div>

                    <status-toogle-button v-model="form.status" :error="form.errors.status"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Status"></status-toogle-button>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit"><i
                            class="fa fa-check-circle"></i> Create Release Note</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/Shared/Breadcrumbs'
    import Button from '@/Shared/Button'
    import Layout from '@/Shared/Layout'
    import LoadingButton from '@/Shared/LoadingButton'
    import SelectInput from '@/Shared/SelectInput'
    import StatusToogleButton from '@/Shared/StatusToogleButton'
    import TextInput from '@/Shared/TextInput'
    import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
    import { ref, inject, toRefs } from 'vue'
    import { Quill, VueEditor } from "vue3-editor"
    export default {
        components: {
            Head,
            Link,
            LoadingButton,
            SelectInput,
            TextInput,
            Breadcrumbs,
            StatusToogleButton,
            Button,
            Quill,
            VueEditor
        },
        layout: Layout,
        props: {
            categories: Array
        },
        remember: 'form',
        setup(props) {
            const { categories } = toRefs(props)
            const form = useForm({
                title: null,
                version_name: null,
                slug: null,
                details: null,
                status: true,
                category_id: null
            })
            const type = ref('create')
            const title = ref('Release Note')
            const url = ref('/backend/release-notes')
            const createUrl = ref('')
            const swal = inject('$swal')
            const store = () => {
                swal({
                    title: 'Are you sure?',
                    text: "You want to proceed with this action",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                }).then((result) => {
                    if (result.isConfirmed) {
                        form.post(`${url.value}`, { forceFormData: true, })
                        swal.fire(
                            'Added!',
                            'Your information has been Added.',
                            'success'
                        )
                    }
                });

            }
            return {
                form,
                type,
                title,
                url,
                createUrl,
                store,
                categories
            }
        }
    }
</script>
